import { render, staticRenderFns } from "./IconPoiTrain.vue?vue&type=template&id=fc6cda90&"
import script from "./IconPoiTrain.vue?vue&type=script&lang=js&"
export * from "./IconPoiTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports